<div>
    <div class="d-flex justify-content-end" style="background-color: black; width: 100%;">
        <img mat-dialog-close src="../../assets/images/iconos/clear-24px.svg" class="mouse-pointer abs-p" alt="">
    </div>
        <img src="../../assets/images/coche/buen-fin-coche.png" alt="" class="img-popup">    
    </div>
    



